import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

// Importing Components
import TwoPartsBanner from '../components/TwoPartsBanner';
import GoodPoint from '../components/GoodPoint';
import LastGoodPoint from '../components/LastGoodPoint';
import SingleProduct from '../components/SingleProduct';
import Footer from '../components/Footer';
import ProductsData from '../components/ProductsData';

// Importing Images
import TwoPartsBannerImgOne from "../images/section2-chair.jpg";
import TwoPartsBannerImgTwo from "../images/section-3wooden-chair-collections.jpg";
import GoodPointOne from "../images/features-1.png";
import GoodPointTwo from "../images/features-2.png";
import GoodPointThree from "../images/features-3.png";
import GoodPointFour from "../images/features-4.png";
import GoodPointFive from "../images/features-5.png";
import LatestProductOne from "../images/ProductImages/wooden-rocking-chair-400x400.jpg";
import LatestProductTwo from "../images/ProductImages/study-table-400x400.jpg";
import LatestProductThree from "../images/ProductImages/round-stool-400x400.jpg";
import LatestProductFour from "../images/ProductImages/office-table-400x400.jpg";



export default function Home() {

  useEffect(() => {
    localStorage.setItem("searchResult", JSON.stringify(ProductsData));
  }, []);

  return (
    <>
      <div className="container-fluid home-container mb-4">
        {/* Header Start*/}
        <div className="row pt-3">
          <div className="col-12 header-home-page">
            <div className="header-headings">
              <h1 className='mb-0'>STYLE</h1>
              <h1 className='mb-0'>COMFORT &</h1>
              <h1 className='mb-0'>AFFORDABLE</h1>
            </div>
            <Link to='/all-products' className='btn rounded-0 header-home-page-btn'>Explore Store</Link>
          </div>
        </div>
        {/* Header End*/}

        {/* TwoPartsBanner One Start */}
        <TwoPartsBanner
          sideImg={TwoPartsBannerImgOne}
          title="Chair Collection!"
          tagline="Launch Offer 15% Off!"
          sidesOrder={[0, 0]}
          spacingSide="s"
          btnLink="sofa"
        />
        {/* TwoPartsBanner One End */}

        {/* TwoPartsBanner Two Start */}
        <TwoPartsBanner
          sideImg={TwoPartsBannerImgTwo}
          title="Modern Collection!"
          tagline="New Season Stock"
          sidesOrder={[2, 1]}
          spacingSide="e"
          btnLink="chair"
        />
        {/* TwoPartsBanner Two End */}

        {/* GoodPoints Banner Start */}
        <div className="container-fluid px-0 mb-5 mt-3 section-3-home-page">
          <div className="row align-items-start">
            <GoodPoint
              img={GoodPointOne}
              title="10 Years Experience"
            />
            <GoodPoint
              img={GoodPointTwo}
              title="Flexible Delivery"
            />
            <GoodPoint
              img={GoodPointThree}
              title="Free Installation"
            />
            <GoodPoint
              img={GoodPointFour}
              title="After Sales Support"
            />
            <LastGoodPoint
              img={GoodPointFive}
              title="5 Years Warranty"
            />
          </div>
        </div>
        {/* GoodPoints Banner End */}

        {/* Sale Banner Start */}
        <div className="row">
          <div className="col-12 section-4-home-page">
            <h2 className='mb-3'>Sale!</h2>
            <h3 className='mb-4'>10% Off On All Products!</h3>
            <Link to='/all-products' className='btn rounded-0 header-home-page-btn'>
              Shop Now
            </Link>
          </div>
        </div>
        {/* Sale Banner End */}

        {/* Latest Products Start */}
        <div className="row section-5-home-page">
          <div className="col-12">
            <h3 className='fw-normal text-center'>Our Latest Products</h3>
            <div className="m-0 p-0 d-flex justify-content-center align-items-center">
              <hr className='underline-design' />
            </div>
          </div>
        </div>

        <div className="row section-6-home-page justify-content-center gap-0">
          <SingleProduct
            productImg={LatestProductOne}
            productCategory="Armchair"
            productTitle="Wooden Rocking Chair"
            productPrice="169.00"
            mb="0"
            product={ProductsData[16]}
          />
          <SingleProduct
            productImg={LatestProductTwo}
            productCategory="Computer table"
            productTitle="Desktop Table with Drawers"
            productPrice="529.00"
            mb="0"
            product={ProductsData[14]}
          />
          <SingleProduct
            productImg={LatestProductThree}
            productCategory="Chair"
            productTitle="Round Short Leg Stool/Chair"
            productPrice="419.00"
            mb="0"
            product={ProductsData[11]}
          />
          <SingleProduct
            productImg={LatestProductFour}
            productCategory="Computer table"
            productTitle="Table with Office Chair"
            productPrice="775.00"
            mb="0"
            product={ProductsData[8]}
          />
        </div>
        {/* Latest Products End */}
      </div>

      <Footer />
    </>
  )
}
